<app-auth-card
  [message]="'Você não tem permissão para acessar esta página.'"
  [loadingVisibility]="false"
  [buttonAcessarVisibility]="false"
></app-auth-card>

